(function(){
  const els = document.querySelectorAll('.ae-reveal');
  if (!els.length) return;
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(entry=>{ if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); } });
  }, { threshold: 0.12 });
  els.forEach(el=>io.observe(el));
  document.addEventListener('click', function(e){
    const link = e.target.closest('a[href^="tel:"],a[href*="wa.me"],a[href*="whatsapp"]');
    if(!link) return;
    window.dataLayer = window.dataLayer || [];
    const href = link.getAttribute('href') || '';
    window.dataLayer.push({ event: href.indexOf('tel:') === 0 ? 'click_call' : 'click_whatsapp', link_url: href, source: 'agency_theme_layer' });
  });
})();


/* Andrea Local SEO MAX - lightweight conversion tracking hooks */
(function(){
  window.dataLayer = window.dataLayer || [];
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form) return;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if(action.indexOf('/contact') !== -1 || form.querySelector('[name^="contact"]')){
      window.dataLayer.push({event:'lead_form_submit', source:'andrea_theme', page_path: location.pathname});
    }
  }, true);
  var topBar = document.querySelector('.ae-top-conversion');
  if(topBar){ window.dataLayer.push({event:'ae_top_conversion_bar_loaded', page_path: location.pathname}); }
})();
